export default __webpack_public_path__ + "6a2f2c7c295b490173d271ba87114111.png";